import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import StackTelasForm from "./StackTelasForm";
import { Cancel } from "@mui/icons-material";
import LayersIcon from "@mui/icons-material/Layers";

const AddStackTelas = ({ mode, defaultData, open, handleClose }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      PaperProps={{
        sx: {
          background: "#fafafa",
          ".dark &": { background: "#0f172a" },
        },
      }}
    >
      <DialogTitle sx={{ p: 0 }}>
        <Box
          sx={{
            background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
            px: 3, py: 2,
            display: "flex", alignItems: "center", justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <LayersIcon sx={{ color: "#fff", fontSize: 24 }} />
            <Typography
              sx={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 700, color: "#fff", fontSize: "1.1rem",
              }}
            >
              {mode === "POST" ? "Nuevo Rollo" : "Editar Rollo"}
            </Typography>
          </Box>
          <IconButton
            onClick={handleClose}
            sx={{ color: "#fff", "&:hover": { background: "rgba(255,255,255,0.15)" } }}
          >
            <Cancel />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        <StackTelasForm
          mode={mode}
          defaultData={defaultData}
          handleClose={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddStackTelas;
